const LANGUAGES = {
  pt: { value: 'pt', label: 'Português', flag: 'br' },
  en: { value: 'en', label: 'English', flag: 'gb' },
  es: { value: 'es', label: 'Español', flag: 'es' },
} as const;

export type LanguageCode = typeof LANGUAGES[keyof typeof LANGUAGES]['value'];

const availableLanguages = Object.values(LANGUAGES);

export default availableLanguages;
